// Static, code-owned documentation for the deterministic signal types the
// system generates. The signal types are hard-coded in the generation engine
// (process-solution.ts), so their descriptions live alongside as code, not in
// the DB. Rendered read-only on Settings → Signals.
import type { SignalStatType } from "@/lib/signal-stats";

export interface SignalCatalogEntry {
  type: SignalStatType;
  title: string;
  description: string;
  datasets: string[];
}

export const SIGNAL_CATALOG: SignalCatalogEntry[] = [
  {
    type: "needs_guidance",
    title: "Needs Guidance",
    description:
      "Raised when a Solution has no forward NOS Guidance on file, so the suggested Intensity had to be projected from its trailing actual hours. Flags a data gap for the RM to chase down — not an Intensity change to apply.",
    datasets: [
      "NOS actual hours (trailing 6 months)",
      "Hours-per-Intensity-point divisor",
      "Current Solution Intensity",
    ],
  },
  {
    type: "guidance_change_pod_change",
    title: "Guidance Change — Pod Change",
    description:
      "Raised when the Intensity suggested from Guidance implies a different Pod composition than the Solution currently runs (e.g. Pair → Trio). Carries the suggested Pod shape and supporting points for the RM to apply.",
    datasets: [
      "NOS forward Guidance hours (next 3 months)",
      "Hours-per-Intensity-point divisor",
      "Intensity → Pod shape ladder",
      "Current Solution Pod composition",
    ],
  },
  {
    type: "intensity_drift",
    title: "Intensity Drift",
    description:
      "Raised when the Intensity suggested from Guidance differs from the Solution's current Intensity but the Pod composition is unchanged. A same-shape Intensity nudge for the RM to confirm.",
    datasets: [
      "NOS forward Guidance hours (next 3 months)",
      "Hours-per-Intensity-point divisor",
      "Current Solution Intensity",
    ],
  },
  {
    type: "resource_off_pod",
    title: "Add Resource",
    description:
      "Raised when a Resource has NOS forward Guidance and/or logged actual hours on the Solution's Demands but holds no active assignment on its Pod. One signal per off-Pod Resource; applying it adds them to a Primary Position or as Supporting. Auto-resolves once they are on the Pod.",
    datasets: [
      "NOS forward Guidance hours (per Resource)",
      "NOS logged actual hours (per Resource)",
      "Active Pod assignments (Primary + Supporting)",
    ],
  },
];
